export const ConversationShimmer = () => (
    <div className="d-flex flex-column gap-3 pe-24 ps-24 pb-24">
        {[1, 2, 3, 4, 5].map((item) => (
            <div key={item} className="shimmer-item p-3 radius-12 bg-light animate-pulse">
                <div className="shimmer-line w-75 h-4 bg-secondary-light mb-2 rounded-pill"></div>
                <div className="shimmer-line w-50 h-3 bg-secondary-light rounded-pill"></div>
            </div>
        ))}
    </div>
);

export const MessageShimmer = () => (
    <div className="d-flex flex-column gap-3">
        {[1, 2, 3].map((item) => (
            <div key={item} className={`d-flex gap-16 mb-16 ${item % 2 === 0 ? 'justify-content-end' : 'justify-content-start'}`}>
                {item % 2 !== 0 && (
                    <div className="img overflow-hidden flex-shrink-0">
                        <div className="w-44-px h-44-px rounded-circle bg-secondary-light animate-pulse"></div>
                    </div>
                )}
                <div className={`info max-w-75 bg-light px-16 py-8 rounded-pill animate-pulse`}>
                    <div className="shimmer-line w-20 h-4 bg-secondary-light mb-2 rounded-pill"></div>
                    <div className="shimmer-line w-100 h-3 bg-secondary-light mb-1 rounded-pill"></div>
                    <div className="shimmer-line w-75 h-3 bg-secondary-light rounded-pill"></div>
                </div>
                {item % 2 === 0 && (
                    <div className="img overflow-hidden flex-shrink-0">
                        <div className="w-44-px h-44-px rounded-circle bg-secondary-light animate-pulse"></div>
                    </div>
                )}
            </div>
        ))}
    </div>
);

export const EmptyState = ({ type }) => (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
        <i className="ri-inbox-line text-5xl text-secondary mb-3"></i>
        <p className="text-secondary mb-0">
            {type === 'conversations' ? 'No conversations found' : 'No messages in this conversation'}
        </p>
    </div>
);

export const convertToIndianTimeZone = (utcTimestamp) => {
    const date = new Date(utcTimestamp);
    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    const indianTime = date.toLocaleString('en-IN', options);
    return indianTime;
  };

  // ✅ Chip filter labels for UI


// ✅ Pagination
export const ITEMS_PER_PAGE = 10;

// ✅ Categorization sets for endedReason
export const SUCCESS_REASONS = new Set([
    'assistant-ended-call',
    'assistant-ended-call-after-message-spoken',
    'assistant-ended-call-with-hangup-task',
    'assistant-forwarded-call',
    'assistant-request-returned-forwarding-phone-number',
    'assistant-said-end-call-phrase',
    'vonage-completed'
]);

export const FAILURE_REASONS = new Set([
    'assistant-error',
    'assistant-not-found',
    'assistant-not-valid',
    'assistant-not-provided',
    'assistant-request-failed',
    'assistant-request-returned-error',
    'assistant-request-returned-invalid-assistant',
    'assistant-request-returned-no-assistant',
    'assistant-request-returned-unspeakable-error',
    'pipeline-no-available-llm-model',
    'call.in-progress.error-pipeline-no-available-llm-model',
    'call.in-progress.error-assistant-did-not-receive-customer-audio',
    'call.in-progress.error-sip-telephony-provider-failed-to-connect-call',
    'twilio-failed-to-connect-call',
    'twilio-reported-customer-misdialed',
    'vonage-failed-to-connect-call',
    'vonage-rejected',
    'call-start-error-neither-assistant-nor-server-set',
    'call.start.error-get-org',
    'call.start.error-get-subscription',
    'call.start.error-get-assistant',
    'call.start.error-get-phone-number',
    'call.start.error-get-customer',
    'call.start.error-get-resources-validation',
    'call.start.error-vapi-number-international',
    'call.start.error-vapi-number-outbound-daily-limit',
    'call.start.error-get-transport',
    'database-error',
    'worker-shutdown',
    'unknown-error'
]);

export const NEUTRAL_REASONS = new Set([
    'assistant-join-timed-out',
    'customer-ended-call',
    'customer-busy',
    'customer-did-not-answer',
    'customer-did-not-give-microphone-permission',
    'phone-call-provider-closed-websocket',
    'phone-call-provider-bypass-enabled-but-no-call-received',
    'call.forwarding.operator-busy',
    'call.ringing.hook-executed-say',
    'call.ringing.hook-executed-transfer',
    'exceeded-max-duration',
    'manually-canceled',
    'silence-timed-out',
    'voicemail'
]);

export const getEndedReasonType = (reason) => {
    if (!reason) return 'unknown';
    if (SUCCESS_REASONS.has(reason)) return 'success';
    if (
        FAILURE_REASONS.has(reason) ||
        reason.startsWith('pipeline-error') ||
        reason.startsWith('call.in-progress.error-vapifault') ||
        reason.startsWith('call.in-progress.error-providerfault')
    ) {
        return 'failure';
    }
    if (NEUTRAL_REASONS.has(reason)) return 'neutral';
    return 'unknown';
};

export const getReasonColorClass = (type) => {
    switch (type) {
        case 'success':
            return 'bg-success-100 text-success-600';
        case 'failure':
            return 'bg-danger-100 text-danger-600';
        case 'neutral':
            return 'bg-warning-100 text-warning-800';
        default:
            return 'bg-secondary text-white';
    }
};


